<script setup lang="ts">
import { inject } from "vue";
import SvgIcon from "../../../../templates/elements/SvgIcon.vue";
import type { AccordionProps } from "../";

const accordionProps = inject<AccordionProps>("accordionContext");
</script>

<template>
  <summary
    class="flex cursor-pointer justify-between gap-3 font-medium marker:content-none hover:text-deep-blue"
    :class="{
      'text-base xl:text-lg': accordionProps?.size === 'small',
      'text-xl xl:text-2xl': accordionProps?.size === 'medium',
      'my-1.5 py-1': accordionProps?.size === 'small' && !accordionProps?.divider,
      'my-2 py-1.5': accordionProps?.size === 'medium' && !accordionProps?.divider,
      'my-2 py-2': accordionProps?.size === 'small' && accordionProps?.divider,
      'my-3 py-3': accordionProps?.size === 'medium' && accordionProps?.divider,
    }"
    data-testid="clr-summary"
  >
    <span>
      <slot />
    </span>
    <SvgIcon
      name="Arrow-Down"
      class="mt-0.5 flex-shrink-0 group-open:rotate-180 motion-safe:transition-transform motion-safe:duration-300"
      :class="{
        'h-5 w-5 xl:h-6 xl:w-6': accordionProps?.size === 'small',
        'h-6 w-6': accordionProps?.size === 'medium',
      }"
    />
  </summary>
</template>
